import React from 'react';

import { IconSizes } from '#ui/MaterialIcon.js';

interface WeatherIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const PRIMARY_COLOR = '#011E1B';
const SECONDARY_COLOR = '#03857B';

// Internal icon components
const CloudDay: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_436_871)">
        <path
          d="M15 15H14.899C14.436 12.718 12.419 11 10 11C7.581 11 5.564 12.718 5.101 15H5C2.791 15 1 16.791 1 19C1 21.209 2.791 23 5 23H15C17.209 23 19 21.209 19 19C19 16.791 17.209 15 15 15Z"
          stroke={PRIMARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.797 11.5039C17.982 11.0369 18.091 10.5319 18.091 9.99994C18.091 7.74094 16.259 5.90894 14 5.90894C12.887 5.90894 11.881 6.35694 11.143 7.07694"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23 6.27197L21.5 9.99997L23 13.728"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23 13.728L21.493 14.34"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.75 1L19.25 4.75L23 6.272"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.735 8.09797L5 6.27197"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.25 1L14 2.5L17.75 1"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 6.272L8.75 4.75L10.25 1"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_436_871">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const CloudMixed: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_436_882)">
        <path
          d="M18 13C18.828 13 19.598 12.748 20.236 12.317C20.662 12.029 21.029 11.662 21.316 11.237C21.748 10.598 22 9.828 22 9C22 8.172 21.748 7.402 21.317 6.764C21.029 6.338 20.662 5.971 20.237 5.684C19.598 5.252 18.828 5 18 5H17.651C16.827 2.671 14.611 1 12 1C9.389 1 7.173 2.671 6.349 5H6C5.172 5 4.402 5.252 3.764 5.683C3.338 5.971 2.971 6.338 2.684 6.763C2.252 7.402 2 8.172 2 9C2 11.209 3.791 13 6 13"
          stroke={PRIMARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 22V18"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 17V23"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.402 18.5L22.598 21.5"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.402 21.5L22.598 18.5"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 17V23"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.402 18.5L6.598 21.5"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.402 21.5L6.598 18.5"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_436_882">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const CloudNight: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_436_893)">
        <path
          d="M23 13.4691C22.8 13.4871 22.598 13.5001 22.393 13.5001C18.596 13.5001 15.518 10.4221 15.518 6.62509C15.518 4.33909 16.639 2.31909 18.356 1.06909"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.356 1.069C18.04 1.028 17.72 1 17.393 1C13.765 1 10.738 3.577 10.043 7"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 23C17.209 23 19 21.209 19 19C19 16.791 17.209 15 15 15H14.899C14.436 12.718 12.419 11 10 11C7.581 11 5.564 12.718 5.101 15H5C2.791 15 1 16.791 1 19C1 21.209 2.791 23 5 23H15Z"
          stroke={PRIMARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_436_893">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const CloudRain: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 13C18.828 13 19.598 12.748 20.236 12.317C20.662 12.029 21.029 11.662 21.316 11.237C21.748 10.598 22 9.828 22 9C22 8.172 21.748 7.402 21.317 6.764C21.029 6.338 20.662 5.971 20.237 5.684C19.598 5.252 18.828 5 18 5H17.651C16.827 2.671 14.611 1 12 1C9.389 1 7.173 2.671 6.349 5H6C5.172 5 4.402 5.252 3.764 5.683C3.338 5.971 2.971 6.338 2.684 6.763C2.252 7.402 2 8.172 2 9C2 11.209 3.791 13 6 13"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 23V19"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 21V17"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 21V17"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const CloudSnow: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 13C18.828 13 19.598 12.748 20.236 12.317C20.662 12.029 21.029 11.662 21.316 11.237C21.748 10.598 22 9.828 22 9C22 8.172 21.748 7.402 21.317 6.764C21.029 6.338 20.662 5.971 20.237 5.684C19.598 5.252 18.828 5 18 5H17.651C16.827 2.671 14.611 1 12 1C9.389 1 7.173 2.671 6.349 5H6C5.172 5 4.402 5.252 3.764 5.683C3.338 5.971 2.971 6.338 2.684 6.763C2.252 7.402 2 8.172 2 9C2 11.209 3.791 13 6 13"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 17V23"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.402 18.5L19.598 21.5"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.402 21.5L19.598 18.5"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 17V23"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.40201 18.5L9.59801 21.5"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.40201 21.5L9.59801 18.5"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Cloudy: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_436_915)">
        <path
          d="M18.951 8.515C18.709 6.537 17.043 5 15 5H14.899C14.436 2.718 12.419 1 10 1C7.581 1 5.564 2.718 5.101 5H5C2.791 5 1 6.791 1 9C1 10.835 2.243 12.365 3.928 12.836"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 23C21.209 23 23 21.209 23 19C23 16.791 21.209 15 19 15H18.899C18.436 12.718 16.419 11 14 11C11.581 11 9.564 12.718 9.101 15H9C6.791 15 5 16.791 5 19C5 21.209 6.791 23 9 23H19Z"
          stroke={PRIMARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_436_915">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const Fog: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.465 13C21.805 12.412 22 11.729 22 11C22 10.172 21.748 9.402 21.317 8.764C21.029 8.338 20.662 7.971 20.237 7.684C19.598 7.252 18.828 7 18 7H17.651C16.827 4.671 14.611 3 12 3C9.389 3 7.173 4.671 6.349 7H6C5.172 7 4.402 7.252 3.764 7.683C3.338 7.971 2.971 8.338 2.684 8.763C2.252 9.402 2 10.172 2 11C2 11.729 2.195 12.412 2.535 13"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 17H21"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 21H21"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Hale: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 13C18.828 13 19.598 12.748 20.236 12.317C20.662 12.029 21.029 11.662 21.316 11.237C21.748 10.598 22 9.828 22 9C22 8.172 21.748 7.402 21.317 6.764C21.029 6.338 20.662 5.971 20.237 5.684C19.598 5.252 18.828 5 18 5H17.651C16.827 2.671 14.611 1 12 1C9.389 1 7.173 2.671 6.349 5H6C5.172 5 4.402 5.252 3.764 5.683C3.338 5.971 2.971 6.338 2.684 6.763C2.252 7.402 2 8.172 2 9C2 11.209 3.791 13 6 13"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 17V17.01"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 21.99V22"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 21.99V22"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17V17.01"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 17V17.01"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Hurricane: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 18.001C3.744 16.329 3 14.252 3 12C3 6.477 7.477 2 13 2H23"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 22H11C16.523 22 21 17.523 21 12C21 9.74802 20.256 7.67102 19 5.99902"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Lightning: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 22L21 9H15L18 2"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 2L3 13H9L6 22"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const MixedPrecipitation: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 11V22"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.237 13.75L16.763 19.25"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.237 19.25L16.763 13.75"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 9C5 9 7 9 7 7C7 5 5 2 5 2C5 2 3 5 3 7C3 9 5 9 5 9Z"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 9C19 9 21 9 21 7C21 5 19 2 19 2C19 2 17 5 17 7C17 9 19 9 19 9Z"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const MoonFirstQuarter: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2V22Z"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.949 11C22.017 11.678 22.016 12.347 21.951 13"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.949 11C22.017 11.678 22.016 12.347 21.951 13"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.461 18.658C19.915 18.15 20.307 17.608 20.638 17.041"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.637 6.96202C20.294 6.37302 19.899 5.83302 19.463 5.34302"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 21.25V21.24"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 2.76V2.75"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const MoonFull: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const MoonLastQuarter: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22V2Z"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.051 13C1.983 12.322 1.984 11.653 2.049 11"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.051 13C1.983 12.322 1.984 11.653 2.049 11"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.539 5.34204C4.086 5.85004 3.693 6.39204 3.362 6.95904"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.363 17.0381C3.706 17.6271 4.101 18.1671 4.537 18.6571"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 2.75V2.76"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 21.24V21.25"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const MoonNew: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.051 13.001C1.983 12.323 1.984 11.654 2.049 11.001"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.051 13.001C1.983 12.323 1.984 11.654 2.049 11.001"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.949 13.001C22.017 12.323 22.016 11.654 21.951 11.001"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.876 21.773C9.21 21.628 8.574 21.42 7.973 21.157"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.026 2.84803C15.402 2.57403 14.766 2.36803 14.125 2.22803"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.638 17.0391C20.295 17.6281 19.9 18.1681 19.464 18.6581"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.539 5.34302C4.086 5.85102 3.693 6.39302 3.362 6.96002"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.461 5.34302C19.915 5.85102 20.307 6.39302 20.638 6.96002"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.363 17.0391C3.706 17.6281 4.101 18.1681 4.537 18.6581"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.974 2.84705C8.598 2.57305 9.234 2.36705 9.875 2.22705"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.123 21.772C14.789 21.627 15.425 21.419 16.026 21.156"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const MoonWaningCrescent: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.051 13C1.983 12.322 1.984 11.653 2.049 11"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.051 13C1.983 12.322 1.984 11.653 2.049 11"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.54 5.34204C4.086 5.85004 3.694 6.39204 3.362 6.95904"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.36299 17.0381C3.70599 17.6271 4.10099 18.1671 4.53699 18.6571"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 21.358C9.591 21.766 10.767 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C10.767 2 9.591 2.234 8.5 2.642"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 2.64209C12.294 4.06209 15 7.71009 15 12.0001C15 16.2901 12.294 19.9381 8.5 21.3581"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const MoonWaningGibbous: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.051 13C1.983 12.322 1.984 11.653 2.049 11"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.051 13C1.983 12.322 1.984 11.653 2.049 11"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 21.54C8.648 21.43 8.306 21.301 7.974 21.156"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.54 5.34204C4.086 5.85004 3.694 6.39204 3.362 6.95904"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.36299 17.0378C3.70599 17.6268 4.10099 18.1668 4.53699 18.6568"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.974 2.84596C8.313 2.69696 8.655 2.56896 9 2.45996"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.879 2.42505C11.393 4.20705 9 7.81705 9 12C9 16.183 11.394 19.7931 14.879 21.5751C18.997 20.3381 22 16.521 22 12C22 7.47905 18.997 3.66205 14.879 2.42505Z"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const MoonWaxingCrescent: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.949 11C22.017 11.678 22.016 12.347 21.951 13"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.949 11C22.017 11.678 22.016 12.347 21.951 13"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.46 18.658C19.914 18.15 20.306 17.608 20.637 17.041"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.637 6.96202C20.294 6.37302 19.899 5.83302 19.463 5.34302"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 2.642C14.409 2.234 13.233 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C13.233 22 14.409 21.766 15.5 21.358"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 21.3581C11.706 19.9381 9 16.2901 9 12.0001C9 7.71009 11.706 4.06209 15.5 2.64209"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const MoonWaxingGibbous: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.949 11C22.017 11.678 22.016 12.347 21.951 13"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.949 11C22.017 11.678 22.016 12.347 21.951 13"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 2.45996C15.352 2.56996 15.694 2.69896 16.026 2.84396"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.46 18.658C19.914 18.15 20.306 17.608 20.637 17.041"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.637 6.96202C20.294 6.37302 19.899 5.83302 19.463 5.34302"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.026 21.1541C15.688 21.3031 15.345 21.4321 15 21.5401"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.121 21.5751C12.607 19.7931 15 16.183 15 12C15 7.81705 12.606 4.20705 9.121 2.42505C5.003 3.66205 2 7.47905 2 12C2 16.521 5.003 20.3381 9.121 21.5751Z"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Moon: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 19.2881C21.694 19.3141 21.387 19.3331 21.074 19.3331C15.28 19.3331 10.583 14.8191 10.583 9.25007C10.583 5.89707 12.293 2.93407 14.913 1.10107"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.914 1.101C14.431 1.041 13.943 1 13.444 1C7.124 1 2 5.925 2 12C2 18.075 7.124 23 13.444 23C16.852 23 19.903 21.56 22 19.288"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const PartlyCloudy: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.913 9.021C17.445 6.174 14.979 4 12 4C9.021 4 6.555 6.174 6.087 9.021C3.243 9.233 1 11.602 1 14.5C1 17.538 3.462 20 6.5 20H17.5C20.538 20 23 17.538 23 14.5C23 11.602 20.757 9.233 17.913 9.021Z"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Rain: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 21C17 21 19.5 21 19.5 18.714C19.5 16.428 17 13 17 13C17 13 14.5 16.429 14.5 18.714C14.5 20.999 17 21 17 21Z"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 9.0999C20 9.0999 22 9.0999 22 7.3289C22 5.5579 20 2.8999 20 2.8999C20 2.8999 18 5.5569 18 7.3289C18 9.1009 20 9.0999 20 9.0999Z"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.0999C12 9.0999 14 9.0999 14 7.3289C14 5.5579 12 2.8999 12 2.8999C12 2.8999 10 5.5569 10 7.3289C10 9.1009 12 9.0999 12 9.0999Z"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 9.0999C4 9.0999 6 9.0999 6 7.3289C6 5.5579 4 2.8999 4 2.8999C4 2.8999 2 5.5569 2 7.3289C2 9.1009 4 9.0999 4 9.0999Z"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 21C7 21 9.5 21 9.5 18.714C9.5 16.428 7 13 7 13C7 13 4.5 16.429 4.5 18.714C4.5 20.999 7 21 7 21Z"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Snow: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 11.75V21.75"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.67 14.25L16.33 19.25"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.67 19.25L16.33 14.25"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 2.25V8.25"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.402 3.75L20.598 6.75"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.402 6.75L20.598 3.75"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 2.25V8.25"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.40199 3.75L8.59799 6.75"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.40199 6.75L8.59799 3.75"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Snowflake: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 3V21"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.20599 7.5L19.794 16.5"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.20599 16.5L19.794 7.5"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Storm: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23 15L17 22"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 15H23"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.071 7.466C17.338 6.578 16.242 6 15 6H14.899C14.436 3.718 12.419 2 10 2C7.581 2 5.564 3.718 5.101 6H5C2.791 6 1 7.791 1 10C1 12.209 2.791 14 5 14H13"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 9L17 15"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Sun: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_436_1052)">
        <path
          d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23 16.556L21.167 12L23 7.444M16.583 23L18.416 18.417L23 16.556M7.417 23L12 21.167L16.583 23M1 16.556L5.583 18.416L7.417 23M1 7.444L2.833 12L1 16.556M7.417 1L5.583 5.583L1 7.444M16.583 1L12 2.833L7.417 1M23 7.444L18.417 5.584L16.583 1"
          stroke={PRIMARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_436_1052">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const Sunrise: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_436_1056)">
        <path
          d="M7 23C7 20.239 9.239 18 12 18C14.761 18 17 20.239 17 23"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.167 23L23 18.444L18.417 16.584L16.583 12L12 13.833L7.417 12L5.584 16.583L1 18.444L2.833 23"
          stroke={PRIMARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 1L8 5"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 9V1"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 5L12 1"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_436_1056">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const Sunset: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_436_1064)">
        <path
          d="M7 23C7 20.239 9.239 18 12 18C14.761 18 17 20.239 17 23"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.167 23L23 18.444L18.417 16.584L16.583 12L12 13.833L7.417 12L5.584 16.583L1 18.444L2.833 23"
          stroke={PRIMARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 9L16 5"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 1V9"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 5L12 9"
          stroke={SECONDARY_COLOR}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_436_1064">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const Tornado: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 2H22"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 6H18"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 10H20"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 14H22"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 18H23"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 22H19"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Wind: React.FC<WeatherIconProps> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.171 4C7.583 2.835 8.694 2 10 2C11.657 2 13 3.343 13 5C13 6.657 11.657 8 10 8H1"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.171 8C17.583 6.835 18.694 6 20 6C21.657 6 23 7.343 23 9C23 10.657 21.657 12 20 12H1"
        stroke={PRIMARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.171 20C15.583 21.165 16.694 22 18 22C19.657 22 21 20.657 21 19C21 17.343 19.657 16 18 16H1"
        stroke={SECONDARY_COLOR}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// Icon mapping
const iconMap: Record<string, React.FC<WeatherIconProps>> = {
  cloudDay: CloudDay,
  cloudMixed: CloudMixed,
  cloudNight: CloudNight,
  cloudRain: CloudRain,
  cloudSnow: CloudSnow,
  cloudy: Cloudy,
  fog: Fog,
  hale: Hale,
  hurricane: Hurricane,
  lightning: Lightning,
  mixedPrecipitation: MixedPrecipitation,
  moonFirstQuarter: MoonFirstQuarter,
  moonFull: MoonFull,
  moonLastQuarter: MoonLastQuarter,
  moonNew: MoonNew,
  moonWaningCrescent: MoonWaningCrescent,
  moonWaningGibbous: MoonWaningGibbous,
  moonWaxingCrescent: MoonWaxingCrescent,
  moonWaxingGibbous: MoonWaxingGibbous,
  moon: Moon,
  partlyCloudy: PartlyCloudy,
  rain: Rain,
  snow: Snow,
  snowflake: Snowflake,
  storm: Storm,
  sun: Sun,
  sunrise: Sunrise,
  sunset: Sunset,
  tornado: Tornado,
  wind: Wind,
};

// Main WeatherIcon component
export interface WeatherIconComponentProps extends Omit<WeatherIconProps, 'size'> {
  icon: string;
  /** Icon size - can be a number (px) or a preset size key matching MaterialIcon sizes */
  size?: number | keyof typeof IconSizes;
}

export const WeatherIcon: React.FC<WeatherIconComponentProps> = ({ icon, size, className, ...props }) => {
  // Type-safe lookup - iconMap has all valid icons, but we need to handle potential undefined
  const IconComponent = iconMap[icon] as React.FC<WeatherIconProps> | undefined;
  if (!IconComponent) {
    console.warn(`Unknown weather icon: ${icon}.`);
    return undefined;
  }

  // Calculate icon size - matches MaterialIcon's behavior
  const iconSize =
    size !== undefined ? (typeof size === 'number' ? size : IconSizes[size as keyof typeof IconSizes]) : undefined;

  // Pass size as width/height to SVG if specified
  const svgProps: WeatherIconProps = {
    ...props,
    className,
    ...(iconSize !== undefined && { width: iconSize, height: iconSize }),
  };

  return <IconComponent {...svgProps} />;
};
